import * as Config from '../../../../../../config';
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from "react-redux";
import {
  setModal,
  addToast,
  updateStorePlaylists,
  incrementStorePlaylists
} from "../../../../../../actions/index";

import ModalCTA from '../../../../modal/ModalCTA';
import ModalButton from '../../../../modal/ModalButton';
import DragItem from '../../../../dnd/DragItem';
import Sortable from '../../Sortable';

import CheckboxSelect from './CheckboxSelect';
import ColumnChecker from '../../ColumnChecker';
import ColumnActions from '../../ColumnActions';
import ColumnUpgrade from '../../ColumnUpgrade';
import ColumnCover from '../../ColumnCover';
import ColumnTrack from '../../ColumnTrack';
import ColumnLabel from '../../ColumnLabel';
import ColumnGenre from '../../ColumnGenre';
import ColumnBpmKey from '../../ColumnBpmKey';
import ColumnMore from '../../ColumnMore';
import ColumnDate from '../../ColumnDate';
import ColumnTime from '../../ColumnTime';
import ColumnRemixer from '../../ColumnRemixer';
import ColumnRowActions from '../../ColumnRowActions';
import ColumnTombstoned from '../../ColumnTombstoned';

import useTrackAccess from '../../hooks/useTrackAccess';

// React.memo(
const ConnectedRowPartial = ({
  item, index, width, height, className = 'item', style,
  isSortable,
  onLoadMore,
  onDropSortable, onDelete, isConnected,
  idParent, nameParent, onClick,
  end,
  api, setModal, addToast,
  updateStorePlaylists, incrementStorePlaylists,
  isTablet, touchEditor,
  dnd = true,
  containerRef = null
}) => {

  const updateParent = (data, newItems = [], type, forceUpdate = null) => {
    if (isConnected) {
      if (newItems.length > 0) {
        if (type === 'update') {
          api.post(`/v4/my/playlists/${idParent}/tracks/bulk/`, { track_ids: newItems }).then( res => {
            const itemsPlaylistAPI = res.data.items.map(x => ({item_id: x.id, track_id: x.track_id}));
            const updateItems = data.map((x,i) => {
              const p = itemsPlaylistAPI.find(y => y.track_id === x.id);
              return { item_id: (p) ? p.item_id : x.item_id, position: i + 1 }
            })

            if (forceUpdate) {
              forceUpdate(itemsPlaylistAPI); // To be able to delete or sortable after a new add sortable from outside
            }

            api.patch(`/v4/my/playlists/${idParent}/tracks/bulk/`, { items: updateItems });
            addToast({ content: <span>{newItems.length} track(s) added to '{nameParent ? nameParent : 'this playlist'}'.</span>, typeClass: 'success', iconStyle: { padding: 16, marginRight: 16 } });
          })
        } else if (type === 'delete') {
          api.del(`/v4/my/playlists/${idParent}/tracks/${newItems[0]}/`);
        }
      } else {
        api.patch(`/v4/my/playlists/${idParent}/tracks/bulk/`, { items: data.map((x,i) => ({ item_id: x.item_id, position: i + 1 })) });
      }
    }

    updateStorePlaylists(idParent, `tracks`, data);
    const nb = (type === `delete`) ? newItems.length * -1 : newItems.length;
    incrementStorePlaylists(idParent, `track_count`, nb);
    updateStorePlaylists(idParent, `length_ms`, data.reduce((total, x) => total + x.length_ms, 0));
  }

  const removeToPlaylist = () => {
    const deleteItem = (index) => () => {
      onDelete(index, updateParent);
      addToast({ content: <span>1 track(s) removed from '{nameParent ? nameParent : 'this playlist'}'.</span>, typeClass: 'neutral', iconStyle: { padding: 16, marginRight: 16 } });
      // previewPlayer.kill();
    }
    setModal({ //V2
      content: (
        <ModalCTA
          title={`Remove track(s)`}
          description={`Are you sure you want to remove the selected track(s)?`}
          styleContainer={{marginTop: `-60%`, marginLeft: `-10%`}}
          styleBody={{gap: 32}}
          classModal={`bottom-reduce`}
        >
          <ModalButton label={`Remove`} className={`red-white`} onClick={deleteItem(index)} keyPress={true} />
          <ModalButton label={`Cancel`} className={`cancel`}  />
        </ModalCTA>
      )
    })
  }

  const {
    isEnabled, isDisabled,
    playerLoadSong,
    previewPlayer, isPreview, stylePreview,
    beginDnD,
    showContextMenu, ContextMenuContent,
    addToCart, isInCart,
    addToPlaylist,
    isTombstoned
  } = useTrackAccess(item, idParent, index, removeToPlaylist /* isSortable ? removeToPlaylist : null*/);

  const onClickRow = (e) => onClick(item, e, index);
  const touchClick = (e) => {
    onClick(item, e, index, true);
    e.stopPropagation();
  }

  const RSizeChecker = 0; // 10;
  const RSizeNumber = 30;
  const RSizeActions = isTablet ? 90: 50;
  const RSizeCover = 48;
  const RSizeExtra = 45;
  const RSizeMore = 30;
  const RSizeKey = 90;
  const RSizeRelease = 95;
  const RSizeTime = 50;

  const RTotal = RSizeChecker + RSizeNumber + RSizeActions + RSizeCover + RSizeMore + RSizeKey + RSizeRelease + RSizeTime + RSizeExtra;
  let RSizeTrack = ((width - RTotal) * 33 / 100);
  let RSizeRemixer = ((width - RTotal) * 20 / 100);
  let RSizeLabel = ((width - RTotal) * 25 / 100);
  let RSizeGenre = ((width - RTotal) * 22 / 100);
  RSizeTrack += (Config.LIST_HEADER_HAS_REMIXER) ? 0 : RSizeRemixer;
  RSizeTrack += (Config.LIST_HAS_MORE) ? 0 : RSizeTime;

  return (
    <>
      <DragItem dnd={dnd && !isTombstoned} type={isEnabled && !isTombstoned ? `TRACK` : `X`} idParent={idParent} partialGrab={touchEditor} begin={beginDnD} end={end} onClick={onClickRow} ContextMenuContent={ContextMenuContent} item={item} onMouseEnter={onLoadMore ? onLoadMore(index) : null} className={`${isPreview && `preview`} ${isTombstoned && `tombstone`} ${(previewPlayer && !previewPlayer.isPlaying) && 'off'} ${className} ${(isDisabled) && `disabled`} `} style={stylePreview({ width, height })}>
        { /*isTablet && */ touchEditor ? (
          <div style={{ width: RSizeChecker + RSizeNumber, zIndex: 500 }} >
            <CheckboxSelect trackID={item.id} style={{marginLeft: 9}} onClick={touchClick}  />
          </div>
        ) : (
          <ColumnChecker width={RSizeNumber} isDisabled={isDisabled} trackID={item.id} value={index + 1} />
        )}
        <ColumnActions width={RSizeActions} keyID={item.id} isPreview={(!previewPlayer.isPlaying || !isPreview)} isTablet={isTablet}
            onClickPlayDeckA={playerLoadSong(1)} onClickPlayDeckB={playerLoadSong(2)}
            onPreviewBackward={previewPlayer.backward} onPreviewForward={previewPlayer.forward} isVisible={!isTombstoned} />
        <ColumnCover width={RSizeCover} item={item} previewPlayer={previewPlayer} hasPreview={!isTombstoned} />
        <ColumnTrack width={RSizeTrack} item={item} includeRemixers={false} containerStyle={{ marginRight: 10 }} isTombstoned={isTombstoned} />
        { (Config.LIST_HEADER_HAS_REMIXER) && (
          <ColumnRemixer width={RSizeRemixer} style={{ zIndex: 50 }} remixers={item.remixers} />
        )}
        <ColumnLabel width={RSizeLabel - 8} item={item} style={{ marginRight: 8 }}  />
        <ColumnGenre width={RSizeGenre} item={item} />
        <ColumnBpmKey width={RSizeKey} item={item} />
        { isEnabled ? (
          <>
            <ColumnDate width={RSizeRelease} date={item.release} />
            <ColumnTime width={RSizeTime} duration={item.length} durationMs={item.length_ms} />
            {!isTombstoned 
              ? (!Config.IFRAME 
                ? <ColumnRowActions width={RSizeExtra} onClickCart={addToCart} isInCart={isInCart} onClickPlaylist={addToPlaylist} />
                : null) 
              : <ColumnTombstoned width={RSizeExtra} />
            }
            <ColumnMore width={RSizeMore} id={item.id} onClick={showContextMenu} hasTouch={touchEditor} />
          </>
        ) : (
          <ColumnUpgrade width={RSizeRelease + RSizeTime + RSizeMore + RSizeExtra} />
        )}
        { isSortable ? <Sortable idParent={idParent} index={index} width={width} height={height} onDrop={onDropSortable} afterSortable={updateParent} containerRef={containerRef} /> : null }
      </DragItem>
    </>
  )

};

ConnectedRowPartial.propTypes = {
  item: PropTypes.object.isRequired,
  idParent: PropTypes.any,
  index: PropTypes.number.isRequired,
  width: PropTypes.any.isRequired,
  height: PropTypes.number.isRequired,
  onClick: PropTypes.func,
  end: PropTypes.func,
  onDropSortable: PropTypes.func,
  onDelete: PropTypes.func,
  isSortable: PropTypes.bool,
  dnd: PropTypes.bool,
  containerRef: PropTypes.any
}

const RowPartial= connect(
  state => ({
    api: state.api,
    isConnected: state.isConnected,
    isTablet: state.layoutTablet,
    touchEditor: state.touchEditor
  }),
  dispatch => ({
    setModal: content => dispatch(setModal(content)),
    addToast: content => dispatch(addToast(content)),
    updateStorePlaylists: (trackID, property, data) => dispatch(updateStorePlaylists(trackID, property, data)),
    incrementStorePlaylists: (trackID, property, data) => dispatch(incrementStorePlaylists(trackID, property, data)),
  })
)(ConnectedRowPartial);

export default RowPartial;
